import { Component, OnInit, Output, Input, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { IQuestionGroup } from "../../shared/models/interfaces/question.group";
import { NgSelectComponent } from '@ng-select/ng-select'

@Component({
  selector: 'app-option-value-question-group',
  templateUrl: './option-value-question-group.component.html',
  styleUrls: ['./option-value-question-group.component.scss']
})
export class OptionValueQuestionGroupComponent implements OnInit, AfterViewInit {

  @ViewChild('#ngQuestionGroupsSelect') ngSelect: NgSelectComponent;

  questionGroupId: number = 0;
  @Input() questionGroups: IQuestionGroup[];
  @Output() questionGroupSelected: EventEmitter<number> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.ngSelect.focus();
    }, 100);
  }

  getPlaceholderText() {
    return "Choose Question Group";
  }

  onQuestionGroupSelected(): void {
    if (this.questionGroupId > 0) {
      this.questionGroupSelected.emit(this.questionGroupId);
    }
  }
}
